<template>
  <div class="ua-ms-content">
    <h5 v-if="showTitle">活动信息</h5>
    <!-- <div class="ua-ms-content__title">活动时间：</div>
    <p>
      <span>{{ pdp.product.miaoshaStartTime }}</span>
      <span style="padding: 0px 2px">-</span>
      <span>{{ pdp.product.miaoshaEndTime }}</span>
    </p> -->
    <div class="ua-ms-content__title">秒杀价格说明：</div>
    <p>1.参加本次秒杀活动的商品在活动期间，活动页面将分别显示商品的 “划线价格”“秒杀价”</p>
    <p>2.本次活动页面所显示的“划线价格”并非原价，仅指活动商品的吊牌价，仅供参考</p>
    <p>3.“秒杀价”为商品参与秒杀促销活动后的价格，具体信息以届时页面展示为准</p>
    <div class="ua-ms-content__title">活动规则：</div>
    <p>1.在此期间内，购买指定商品可享受秒杀价格，部分商品不参与秒杀活动，实际以页面信息为准</p>
    <p>2.秒杀商品不与其他优惠活动同享，不可叠加优惠券，不参与买赠活动</p>
  </div>
</template>

<script>
import { PDP } from '../lib/mixins';

export default {
  name: 'MiaoShaContent',
  mixins: [PDP],
  props: { showTitle: { type: Boolean, default: true } }
};
</script>

<style lang="scss" layout="pc" description="网页端样式">
.ua-ms-content {
  h5 {
    color: var(--main-color-ua-dark-grey, #14141e);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 137.5% */
    margin-bottom: 16px;
  }

  p {
    color: var(--secondary-color-ua-cool-grey-04, #50505a);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 175%; /* 24.5px */
    margin-top: 4px;
  }

  &__title {
    color: var(--main-color-ua-dark-grey, #14141e);
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 142.857% */
    margin-top: 20px;

    &:first-of-type {
      margin-top: 16px;
    }
  }
}
</style>

<style lang="scss" layout="mobile" description="移动端样式">
.ua-ms-content.is-mobile {
}
</style>
